import { render, staticRenderFns } from "./ProjectDocumentList.vue?vue&type=template&id=fad4419e&scoped=true"
import script from "./ProjectDocumentList.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentList.vue?vue&type=script&lang=js"
import style0 from "./ProjectDocumentList.vue?vue&type=style&index=0&id=fad4419e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fad4419e",
  null
  
)

export default component.exports